var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo / linkedin",
    clipPath: "url(#clip0_3753_7533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 0H4.16667C1.86583 0 0 1.86583 0 4.16667V15.8333C0 18.1342 1.86583 20 4.16667 20H15.8333C18.135 20 20 18.1342 20 15.8333V4.16667C20 1.86583 18.135 0 15.8333 0ZM6.66667 15.8333H4.16667V6.66667H6.66667V15.8333ZM5.41667 5.61C4.61167 5.61 3.95833 4.95167 3.95833 4.14C3.95833 3.32833 4.61167 2.67 5.41667 2.67C6.22167 2.67 6.875 3.32833 6.875 4.14C6.875 4.95167 6.2225 5.61 5.41667 5.61ZM16.6667 15.8333H14.1667V11.1633C14.1667 8.35667 10.8333 8.56917 10.8333 11.1633V15.8333H8.33333V6.66667H10.8333V8.1375C11.9967 5.9825 16.6667 5.82333 16.6667 10.2008V15.8333Z",
    fill: "#2867B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66665 15.8333H4.16665V6.66659H6.66665V15.8333ZM5.41665 5.60992C4.61165 5.60992 3.95831 4.95159 3.95831 4.13992C3.95831 3.32826 4.61165 2.66992 5.41665 2.66992C6.22165 2.66992 6.87498 3.32826 6.87498 4.13992C6.87498 4.95159 6.22248 5.60992 5.41665 5.60992ZM16.6666 15.8333H14.1666V11.1633C14.1666 8.35659 10.8333 8.56909 10.8333 11.1633V15.8333H8.33331V6.66659H10.8333V8.13742C11.9966 5.98242 16.6666 5.82326 16.6666 10.2008V15.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3753_7533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a7a8a7b857762aef9fef4b7ab7251ec3.svg";
export { ForwardRef as ReactComponent };